import React, { FC, useState, ReactNode } from "react";
import classNames from "classnames";

import { Button } from "../Button";
import Icon from "../Icon";

type Props = {
  value?: string;
  dataTest?: string;
  className?: string;
  contentClassName?: string;
  children?: ReactNode;
};

export const CopyButton: FC<Props> = ({
  value = "",
  dataTest,
  className,
  contentClassName,
  children,
}) => {
  const [success, setSuccess] = useState(false);

  const handleClick = async () => {
    await navigator.clipboard.writeText(value);
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
    }, 2000);
  };

  const content = children ? <>{children} </> : undefined;

  return (
    <>
      <Button
        className={classNames("border-0 bg-transparent", className)}
        contentClassName={contentClassName}
        dataTest={dataTest}
        icon={!children}
        onClick={handleClick}
        variant={Button.variant.TERTIARY}
        size={Button.size.SMALL}
        disabled={success}
      >
        {content}
        {!success ? (
          <Icon icon="Copy" size={16} className="theme-text-secondary" />
        ) : (
          <Icon icon="Checkmark" size={24} className="theme-text-success" />
        )}
      </Button>
    </>
  );
};
